import React, { useEffect, useState } from 'react'

import { useOtChainState } from '@react/redux/store'

import { EthAddr } from '@shared/SchemaTypes'

import { Typography } from '@mui/material'
import { fetchPoolEventCTOs } from '@react/fetchers/PoolFetchers'
import ReportExplorer from '@react/reporting/ReportExplorer'
import { ReportDataShape } from '@shared/ReportDefinitionCTO'
import { PoolEventCTO } from '@shared/sharedTypes'
import { LenderLedgerEventTypes } from '@shared/templateApx'

interface LenderInvestmentLedgerProps {
  poolAddr: EthAddr
  lenderAddr?: EthAddr
}

export const LenderInvestmentLedger: React.FC<LenderInvestmentLedgerProps> = ({ poolAddr, lenderAddr }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [fetchDataError, setFetchDataError] = useState<any | undefined>(undefined)

  const {
    stageConfiguration: { restAPIKey, serverApiBaseUrl },
    userConnection: { accountAddr },
    chainConfiguration: { providerReadOnly },
  } = useOtChainState()
  const [rows, setRows] = useState<PoolEventCTO[]>([])

  useEffect(() => {
    async function fetchEvents(): Promise<void> {
      try {
        setLoading(true)
        setFetchDataError(undefined)
        if (providerReadOnly && poolAddr && accountAddr && serverApiBaseUrl && restAPIKey) {
          const events: PoolEventCTO[] = await fetchPoolEventCTOs(
            serverApiBaseUrl,
            restAPIKey,
            poolAddr,
            lenderAddr ?? accountAddr
          )
          const investmentEvents = events.filter((event: PoolEventCTO) =>
            LenderLedgerEventTypes.includes(event.eventType)
          )
          setRows(investmentEvents)
        }
      } catch (error: any) {
        setFetchDataError(error)
      } finally {
        setLoading(false)
      }
    }

    fetchEvents()
  }, [poolAddr, accountAddr, lenderAddr])

  const defaultColumnNames = ['transactionHash', 'eventName', 'timestamp', 'assets', 'shares']
  return (
    <>
      {rows.length === 0 && <Typography>You do not have any investment events at this time.</Typography>}
      <ReportExplorer
        loading={loading}
        fetchDataError={fetchDataError}
        reportDataShape={ReportDataShape.POOL_EVENTS}
        defaultColumnNames={defaultColumnNames}
        rows={rows}
      />
    </>
  )
}
